import React from "react";

const Footer = () => {
  return (
      <div className="card-body small-footer">
        <p className="text-center"> © 2022 Clapingo Education Private Limited </p>        
      </div>

  );
};

export default Footer;
